import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'
import {
  findObjectByTestName,
  getFeedbackByTIN,
  getFeedBackDivIdByTIN,
  getTestNameFromIframe,
  setWaitingId,
  setFeedbackId,
  isCellPhoneInPortrait
} from '../Common'

export const Home = ({ data, getPollingData }) => {
  useEffect(() => {
    const handleComponentMount = () => {
      let testName = getTestNameFromIframe()
      setWaitingId(testName)
      setFeedbackId(testName)

      //The following will restore feedback after delivered if user switches pages and returns
      let thisComponentObj = findObjectByTestName('Barista2')
      if (thisComponentObj !== null && thisComponentObj !== undefined) {
        let TIN = Object.keys(thisComponentObj)[0]
        let feedback = getFeedbackByTIN(thisComponentObj, TIN)
        let feedBackDivId = getFeedBackDivIdByTIN(thisComponentObj, TIN)
        if (feedback) {
          $(feedBackDivId).html(feedback)
        }
      }

      // Add event listener for window resize
      window.addEventListener('resize', handleResize)
      handleResize()

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }
    handleComponentMount()
  }, []) // The empty dependency array ensures this runs only once when the component mounts

  const handleResize = () => {
    if ($('#feedbackBox :first-child').length) {
      console.log('width: ', window.innerWidth)
      console.log('height: ', window.innerHeight)
      console.log('cellPhoneInPortrait: ', isCellPhoneInPortrait())
      console.log(
        'data in feedbackBox: ',
        $('#feedbackBox :first-child').html().length
      )
      if (
        isCellPhoneInPortrait() &&
        $('#feedbackBox :first-child').html().length < 20
      ) {
        $('.button-container-lower')
          .css('position', 'relative')
          .css('top', '-200px')
      } else {
        $('.button-container-lower')
          .css('position', 'relative')
          .css('top', '0px')
      }
    }
  }

  return (
    <div style={{ height: '100vh', overflowY: 'auto', marginTop: '120px' }}>
      <div style={{ width: '100%', height: 'auto', position: 'relative' }}>
        <div className='grayPageContainer'>
          <span
            style={{
              color: 'darkblue',
              fontSize: '24px',
              marginTop: '20px',
              top: '100px'
            }}
          >
            Welcome to <strong>DoTell!</strong>
            <br></br><i style={{fontSize: '20px', color: 'black'}}>Experience conversational tests. Consider next steps to realize their benefits.</i>
          </span>

          <div class='button-container'>
            <button className='homeButton'>
              <Link to='/theory' style={{ color: 'white' }}>
                Theory of Conversational Testing
              </Link>
            </button>

            <button className='homeButton'>
              <Link to='/vsmultiple' style={{ color: 'white' }}>
                Conversational vs Multiple Choice Testing
              </Link>
            </button>
          </div>

          <div className='iFrameContainer'>
            <div className='abox'>
              {/* <span id='cardCaption'>Got retail Skills?</span> */}
            </div>
            <div className='abox'>
              <div
                id='cardCaption'
                /* style={{position: 'relative', left: '-250px', top: '70px'}} */
              >
                Got barista skills?
              </div>
              <iframe
                src='https://take.tellmethis.info/?TIN=002336881&testName=Barista2&accountId=MFpaLrYQL&mode=C&clientLogo=true&clr=black&t0=2288aa&t1=d1e0e3&extUserId=00000&reload=true&msg=%253Cdiv%253E%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253EClick%2520to%2520test%2520your%253C%2Fdiv%253E%253Cdiv%253Ebarista%2520skills.%253C%2Fdiv%253E%253Cdiv%253E%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253EGet%2520feedback%2520in%2520a%2520%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253Eminute%2520or%2520two!%253Cbr%253E%253C%2Fdiv%253E'
                //src='https://tmt-taker.herokuapp.com/?TIN=002336881&testName=Barista2&accountId=MFpaLrYQL&mode=C&clientLogo=true&clr=black&t0=2288aa&t1=d1e0e3&extUserId=00000&reload=true&msg=%253Cdiv%253E%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253EClick%2520to%2520test%2520your%253C%2Fdiv%253E%253Cdiv%253Ebarista%2520skills.%253C%2Fdiv%253E%253Cdiv%253E%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253EGet%2520feedback%2520in%2520a%2520%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253Eminute%2520or%2520two!%253Cbr%253E%253C%2Fdiv%253E'
                //src='http://localhost:5000/?TIN=044850966&testName=Barista 1&accountId=aNy2en29k&mode=C&clientLogo=true&clr=black&t0=aabbcc&t1=d1e0e3&extUserId=00000&extUserEmail=00000&msg=%253Cdiv%253E%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253EClick%2520to%2520test%2520your%253C%2Fdiv%253E%253Cdiv%253Ebarista%2520skills.%253C%2Fdiv%253E%253Cdiv%253E%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253EGet%2520feedback%2520in%2520a%2520%253Cbr%253E%253C%2Fdiv%253E%253Cdiv%253Eminute%2520or%2520two!%253Cbr%253E%253C%2Fdiv%253E'
                width='314'
                height='217'
                frameBorder='0'
                allow='microphone'
                style={{ borderRadius: '12px' }}
              ></iframe>
            </div>
            <div id='feedbackBox' className='abox'>
              <div
                id='feedback-Barista2' //feedback div needs testname in id
                style={{
                  padding: '12px',
                  justifyContent: 'left',
                  alignItems: 'left',
                  /* height: '200px', */
                  width: '100%',
                  overflow: 'auto',
                  margin: 'auto',
                  border: 'none' //'inset thin gray'
                }}
              ></div>
              <span
                className='waitingGif'
                id='waitingGif-Barista2'
                style={{
                  visibility: 'hidden',
                  position: 'relative',
                  zIndex: 10
                }}
              >
                <img src='waiting.gif' width='50'></img>
              </span>
            </div>
          </div>
          <div
            style={{
              width: '100%',
              margin: 'auto',
              textAlign: 'center',
              position: 'relative'
            }}
          >
            <div class='button-container-lower'>
              <button className='homeButton'>
                <Link to='/sampletests' style={{ color: 'white' }}>
                  Sample Tests
                </Link>
              </button>

              <button className='homeButton'>
                <Link to='/nextsteps' style={{ color: 'white' }}>
                  Next Steps
                </Link>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: '120px' }}>&nbsp;</div>
    </div>
  )
}
